(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var $ = window.jQuery || null;
    var lastScrollY = Math.max(window.pageYOffset || 0, 0);

    function initCartLoadingCursor() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return;
      }

      var loadingCursor = document.createElement('span');
      var pointerX = -100;
      var pointerY = -100;

      loadingCursor.className = 'cart-loading-cursor';
      loadingCursor.setAttribute('aria-hidden', 'true');
      document.body.appendChild(loadingCursor);

      function isBusyQuantityControl(element) {
        return Boolean(
          element &&
            (element.closest(".cart-drawer[aria-busy='true'] .cart-drawer__qty-button") ||
              element.closest(
                ".main-cart-page__layout[aria-busy='true'] .main-cart-page__qty-button, " +
                  ".main-cart-page__layout[aria-busy='true'] .main-cart-page__quantity-input"
              ))
        );
      }

      function updateLoadingCursor() {
        var hoveredElement = document.elementFromPoint(pointerX, pointerY);
        loadingCursor.classList.toggle('is-visible', isBusyQuantityControl(hoveredElement));
      }

      document.addEventListener('pointermove', function (event) {
        pointerX = event.clientX;
        pointerY = event.clientY;
        loadingCursor.style.left = pointerX + 'px';
        loadingCursor.style.top = pointerY + 'px';
        updateLoadingCursor();
      });

      document.addEventListener('pointerleave', function () {
        loadingCursor.classList.remove('is-visible');
      });

      new MutationObserver(updateLoadingCursor).observe(document.body, {
        attributes: true,
        attributeFilter: ['aria-busy'],
        subtree: true
      });
    }

    initCartLoadingCursor();

    function getHeaderGroupElement() {
      return document.querySelector('.shopify-section-group-header-group:has(.header)');
    }

    function getHeaderElement() {
      return document.querySelector('.shopify-section-group-header-group .header') || document.querySelector('.header');
    }

    function getAnnouncementBarElement() {
      return document.querySelector('.shopify-section-group-header-group .announcement-bar') || document.querySelector('.announcement-bar');
    }

    function getTransparentBanner() {
      var mainContent = document.getElementById('MainContent');

      if (!mainContent) {
        return null;
      }

      var firstSectionBanner = mainContent.querySelector(
        '.shopify-section:first-child .index-banner[data-transparent-header="true"]'
      );

      if (firstSectionBanner) {
        return firstSectionBanner;
      }

      return mainContent.querySelector('.index-banner[data-transparent-header="true"]');
    }

    function hasTransparentHeaderOverlay() {
      return Boolean(getTransparentBanner());
    }

    function getHeaderHeight() {
      var headerElement = getHeaderElement();
      if (headerElement) {
        return Math.round(headerElement.getBoundingClientRect().height);
      }

      return 0;
    }

    function getAnnouncementHeight() {
      var announcementBarElement = getAnnouncementBarElement();
      if (!announcementBarElement || announcementBarElement.style.display === 'none') {
        return 0;
      }

      return Math.round(announcementBarElement.getBoundingClientRect().height);
    }

    function updateHeaderDependentUI() {
      var headerElement = getHeaderElement();
      var headerHeight = getHeaderHeight();
      var announcementHeight = getAnnouncementHeight();
      var currentScrollY = Math.max(window.pageYOffset || window.scrollY || 0, 0);
      var transparentHeader = hasTransparentHeaderOverlay();
      var mainContent = document.getElementById('MainContent');

      document.body.classList.toggle('has-transparent-header', transparentHeader);
      document.documentElement.classList.toggle('has-transparent-header', transparentHeader);

      if (headerElement) {
        headerElement.style.top = Math.max(announcementHeight - currentScrollY, 0) + 'px';
      }

      if (mainContent) {
        mainContent.style.paddingTop = transparentHeader
          ? '0px'
          : headerHeight + 'px';
      }

      document.querySelectorAll('.sticky-top').forEach(function (element) {
        element.style.top = announcementHeight + headerHeight + 30 + 'px';
      });

      document.querySelectorAll('.nav-mobile').forEach(function (element) {
        element.style.height = window.innerHeight - announcementHeight - headerHeight + 'px';
      });

      document.querySelectorAll('.predictive-search .wrapper').forEach(function (element) {
        element.style.marginTop = '0';
      });

      document
        .querySelectorAll('.header-nav-section, .main-support-nav, .main-product-support-nav')
        .forEach(function (element) {
          element.style.top = announcementHeight + headerHeight + 'px';
        });

      document.documentElement.style.setProperty('--headerHeight', Math.round(headerHeight) + 'px');
      document.documentElement.style.setProperty('--announcementHeight', Math.round(announcementHeight) + 'px');
    }

    function updateHeaderScrollState() {
      var headerElement = getHeaderElement();
      if (!headerElement) {
        return;
      }

      var scrollBehavior = headerElement.getAttribute('data-scroll-behavior') || 'always';
      var currentScrollY = Math.max(window.pageYOffset || window.scrollY || 0, 0);
      var headerHeight = getHeaderHeight();
      var announcementHeight = getAnnouncementHeight();
      var threshold = Math.max(headerHeight + announcementHeight, 30);
      var transparentHeader = hasTransparentHeaderOverlay();
      var shouldHide = false;
      var headerTopOffset = Math.max(announcementHeight - currentScrollY, 0);
      var megaOpen = headerElement.classList.contains('header--mega-open');
      var transparentAtTop = transparentHeader && currentScrollY < announcementHeight + 2 && !megaOpen;

      headerElement.style.top = headerTopOffset + 'px';
      headerElement.style.background = transparentAtTop ? 'transparent' : '#000';
      headerElement.style.boxShadow = transparentAtTop ? 'none' : '0px 3px 6px 1px rgba(0,0,0,0.1)';

      if (currentScrollY <= threshold || scrollBehavior === 'always') {
        shouldHide = false;
      } else if (scrollBehavior === 'show_on_scroll_up') {
        shouldHide = currentScrollY > lastScrollY;
      } else if (scrollBehavior === 'show_on_scroll_down') {
        shouldHide = currentScrollY < lastScrollY;
      }

      headerElement.classList.toggle('header--scroll-hidden', shouldHide);
      headerElement.classList.toggle('header--transparent-top', transparentAtTop);
      document.body.classList.toggle('has-transparent-header-top', transparentAtTop);
      document.documentElement.classList.toggle('has-transparent-header-top', transparentAtTop);
      lastScrollY = currentScrollY;
    }

    function initAnnouncementBar() {
      var announcementBarElement = getAnnouncementBarElement();
      if (!announcementBarElement) {
        updateHeaderDependentUI();
        updateHeaderScrollState();
        return;
      }

      if (window.Swiper) {
        announcementBarElement.querySelectorAll('.announcement-swiper').forEach(function (container) {
          var autoplaySeconds = Number(container.getAttribute('data-autoplay')) || 0;
          var autoplayEnabled = autoplaySeconds > 0;
          var slideCount = container.querySelectorAll('.swiper-slide').length;

          function updateAnnouncementSlideHeight(swiperInstance) {
            swiperInstance.slides.forEach(function (slide) {
              slide.style.height = '';
            });
            container.style.height = '';
            var wrapper = container.querySelector('.swiper-wrapper');
            if (wrapper) {
              wrapper.style.height = '';
            }

            if (typeof swiperInstance.updateAutoHeight === 'function') {
              swiperInstance.updateAutoHeight(0);
            }

            window.requestAnimationFrame(function () {
              updateHeaderDependentUI();
              updateHeaderScrollState();
              window.dispatchEvent(new CustomEvent('header:heightchange'));
            });
          }

          var swiper = new window.Swiper(container, {
            direction: 'horizontal',
            loop: slideCount > 1,
            speed: 400,
            autoHeight: true,
            autoplay: autoplayEnabled
              ? {
                  delay: autoplaySeconds * 1000,
                  disableOnInteraction: false
                }
              : false,
            on: {
              init: function () {
                updateAnnouncementSlideHeight(this);
              },
              slideChangeTransitionEnd: function () {
                updateAnnouncementSlideHeight(this);
              }
            }
          });

          window.addEventListener('resize', function () {
            updateAnnouncementSlideHeight(swiper);
          });
        });
      }

      var countdownBar = announcementBarElement.querySelector('.countdown-bar');
      if (countdownBar) {
        var targetDate = new Date(countdownBar.getAttribute('data-set-date')).getTime();
        var countdownInterval = setInterval(function () {
          var now = new Date().getTime();
          var timeDifference = targetDate - now;

          var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

          days = days < 10 ? '0' + days : String(days);
          hours = hours < 10 ? '0' + hours : String(hours);
          minutes = minutes < 10 ? '0' + minutes : String(minutes);
          seconds = seconds < 10 ? '0' + seconds : String(seconds);

          announcementBarElement.querySelectorAll('.data-day').forEach(function (element) {
            element.textContent = days;
          });
          announcementBarElement.querySelectorAll('.data-hours').forEach(function (element) {
            element.textContent = hours;
          });
          announcementBarElement.querySelectorAll('.data-minutes').forEach(function (element) {
            element.textContent = minutes;
          });
          announcementBarElement.querySelectorAll('.data-seconds').forEach(function (element) {
            element.textContent = seconds;
          });

          if (timeDifference < 0) {
            clearInterval(countdownInterval);
            announcementBarElement
              .querySelectorAll('.data-day, .data-hours, .data-minutes, .data-seconds')
              .forEach(function (element) {
                element.textContent = '00';
              });
            countdownBar.style.display = 'none';
            updateHeaderDependentUI();
          }
        }, 1000);
      }

      announcementBarElement.querySelectorAll('.announcement-close').forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          announcementBarElement.style.transition = 'height 0.2s ease, opacity 0.2s ease, margin 0.2s ease';
          announcementBarElement.style.height = announcementBarElement.getBoundingClientRect().height + 'px';

          window.requestAnimationFrame(function () {
            announcementBarElement.style.overflow = 'hidden';
            announcementBarElement.style.opacity = '0';
            announcementBarElement.style.height = '0px';
            announcementBarElement.style.margin = '0';

            window.setTimeout(function () {
              announcementBarElement.style.display = 'none';
              updateHeaderDependentUI();
              updateHeaderScrollState();
              window.dispatchEvent(new CustomEvent('header:heightchange'));
            }, 220);
          });
        });
      });

      updateHeaderDependentUI();
      updateHeaderScrollState();
    }

    function initHeaderSearch() {
      var panel = document.querySelector('#HeaderSearchPanel');
      var form = document.querySelector('.header-search-form');
      var input = document.querySelector('#HeaderSearchInput');
      var content = document.querySelector('.header-search-content');
      var results = document.querySelector('#HeaderSearchResults');
      var queryList = document.querySelector('[data-header-search-queries]');
      var viewAll = document.querySelector('[data-header-search-view-all]');
      var triggers = document.querySelectorAll('.header-search-trigger');
      var closeButton = document.querySelector('[data-header-search-close]');
      var timer = null;
      var activeRequest = null;

      if (!panel || !form || !input || !content || !results || !triggers.length) {
        return;
      }

      function setOpen(isOpen) {
        panel.hidden = !isOpen;
        document.body.classList.toggle('header-search-open', isOpen);
        triggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', String(isOpen));
        });

        if (isOpen) {
          window.requestAnimationFrame(function () {
            input.focus();
          });
        } else {
          content.hidden = true;
          input.setAttribute('aria-expanded', 'false');
        }
      }

      function renderQueries(queries, query) {
        if (!queryList) {
          return;
        }

        function appendHighlightedText(container, text) {
          var escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          var parts = text.split(new RegExp('(' + escapedQuery + ')', 'ig'));

          parts.forEach(function (part) {
            if (part.toLowerCase() === query.toLowerCase()) {
              var highlight = document.createElement('mark');
              highlight.className = 'header-search-sidebar__highlight';
              highlight.textContent = part;
              container.appendChild(highlight);
            } else if (part) {
              container.appendChild(document.createTextNode(part));
            }
          });
        }

        queryList.replaceChildren();
        (queries.length ? queries : [{ text: query, url: '/search?q=' + encodeURIComponent(query) }])
          .slice(0, 5)
          .forEach(function (suggestion) {
            var item = document.createElement('li');
            var link = document.createElement('a');
            link.href = suggestion.url || '/search?q=' + encodeURIComponent(suggestion.text || query);
            appendHighlightedText(link, suggestion.text || query);
            item.appendChild(link);
            queryList.appendChild(item);
          });
      }

      function renderResults(html, payload, query) {
        results.innerHTML = html;
        renderQueries(
          payload && payload.resources && payload.resources.results
            ? payload.resources.results.queries || []
            : [],
          query
        );

        if (viewAll) {
          var viewAllUrl = new URL(form.action, window.location.origin);
          viewAllUrl.searchParams.set('q', query);
          viewAllUrl.searchParams.set('type', 'product');
          viewAllUrl.searchParams.set('options[prefix]', 'last');
          viewAll.href = viewAllUrl.toString();

          var resultGrid = results.querySelector('[data-result-count]');
          var resultCount = resultGrid ? Number(resultGrid.getAttribute('data-result-count')) || 0 : 0;
          viewAll.textContent = 'View ' + resultCount + ' ' + (resultCount === 1 ? 'Item' : 'Items');
        }

        content.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function fetchSuggestions(query) {
        if (activeRequest && typeof activeRequest.abort === 'function') {
          activeRequest.abort();
        }

        if (query.length < 2) {
          content.hidden = true;
          input.setAttribute('aria-expanded', 'false');
          return;
        }

        var params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', '6');
        params.set('resources[options][unavailable_products]', 'hide');
        var productParams = new URLSearchParams();
        productParams.set('view', 'predictive');
        productParams.set('q', query);
        productParams.set('type', 'product');
        productParams.set('options[prefix]', 'last');
        activeRequest = new AbortController();

        window.Promise.all([
          window.fetch('/search/suggest.json?' + params.toString(), {
            signal: activeRequest.signal,
            headers: { Accept: 'application/json' }
          }).then(function (response) {
            if (!response.ok) throw new Error('Header predictive search request failed');
            return response.json();
          }),
          window.fetch('/search?' + productParams.toString(), {
            signal: activeRequest.signal,
            headers: { Accept: 'text/html' }
          }).then(function (response) {
            if (!response.ok) throw new Error('Header product search request failed');
            return response.text();
          })
        ])
          .then(function (responses) {
            renderResults(responses[1], responses[0], query);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') {
              return;
            }

            content.hidden = true;
            input.setAttribute('aria-expanded', 'false');
          });
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          setOpen(panel.hidden);
        });
      });

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          setOpen(false);
        });
      }

      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        var query = input.value.trim();

        if (query.length < 2) {
          fetchSuggestions(query);
          return;
        }

        timer = window.setTimeout(function () {
          fetchSuggestions(query);
        }, 180);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setOpen(false);
        }
      });

      form.addEventListener('submit', function () {
        setOpen(false);
      });
    }

    function initHeaderInteractions() {
      if (initHeaderInteractions.didInit) {
        return;
      }

      var headerElement = getHeaderElement();
      if (!headerElement || !headerElement.querySelector('.header-wrapper')) {
        return;
      }

      initHeaderInteractions.didInit = true;

      var desktopDropHideTimer = null;

      function clearDesktopDropHideTimer() {
        if (desktopDropHideTimer) {
          window.clearTimeout(desktopDropHideTimer);
          desktopDropHideTimer = null;
        }
      }

      function scheduleDesktopDropHide(delay) {
        clearDesktopDropHideTimer();
        desktopDropHideTimer = window.setTimeout(function () {
          hideDesktopDrops();
        }, delay || 120);
      }

      headerElement.addEventListener('mouseenter', function () {
        clearDesktopDropHideTimer();
      });

      headerElement.addEventListener('mouseleave', function () {
        scheduleDesktopDropHide(120);
      });

      function hideDesktopDrops() {
        document.querySelectorAll('.drops .mega-menu').forEach(function (drop) {
          drop.classList.remove('is-visible');
        });

        headerElement.querySelectorAll('.nav-items .underline').forEach(function (underline) {
          underline.style.width = '0';
        });

        headerElement.classList.remove('header--mega-open');
        updateHeaderScrollState();
      } 

      function positionDrop(dropElement, triggerElement) {
        if (!dropElement || !triggerElement) {
          return;
        }

        if (dropElement.classList.contains('mega-menu')) {
          dropElement.style.left = '0px';
          return;
        }

        var triggerRect = triggerElement.getBoundingClientRect();
        var dropRect = dropElement.getBoundingClientRect();
        var leftPosition = triggerRect.left + window.scrollX + triggerRect.width / 2 - dropRect.width / 2;
        dropElement.style.left = Math.max(leftPosition, 0) + 'px';
      }

      function showDesktopDrop(triggerElement) {
        if (!triggerElement) {
          return;
        }

        var dropValue = triggerElement.getAttribute('data-drop');
        hideDesktopDrops();

        if (!dropValue) {
          return;
        }

        var dropElement = document.querySelector('.drops > .mega-menu[data-drop="' + dropValue + '"]');
        if (!dropElement) {
          return;
        }

        var underline = triggerElement.querySelector('.underline');
        if (underline) {
          underline.style.width = '100%';
        }

        dropElement.classList.add('is-visible');
        positionDrop(dropElement, triggerElement);
        headerElement.classList.toggle('header--mega-open', dropElement.classList.contains('mega-menu'));
        updateHeaderScrollState();

        var firstTabTrigger = dropElement.querySelector('.mega-nav');
        var firstTab = dropElement.querySelector('.mega-tab');

        dropElement.querySelectorAll('.mega-nav').forEach(function (item, index) {
          item.classList.toggle('active', index === 0);
        });

        dropElement.querySelectorAll('.mega-tab').forEach(function (item, index) {
          item.classList.toggle('active', index === 0);
        });

        if (firstTabTrigger) {
          firstTabTrigger.classList.add('active');
        }

        if (firstTab) {
          firstTab.classList.add('active');
        }
      }

      var navItems = headerElement.querySelector('.nav-items');
      var dropsWrapper = headerElement.querySelector('.drops');

      if (navItems && dropsWrapper) {
        navItems.querySelectorAll('.nav-item[data-drop]').forEach(function (item) {
          function handleDesktopTriggerHover() {
            clearDesktopDropHideTimer();
            showDesktopDrop(item);
          }

          item.addEventListener('mouseenter', handleDesktopTriggerHover);
          item.addEventListener('mouseover', handleDesktopTriggerHover);
          item.addEventListener('focus', handleDesktopTriggerHover);
        });

        navItems.addEventListener('mouseenter', function () {
          clearDesktopDropHideTimer();
        });

        dropsWrapper.addEventListener('mouseenter', function () {
          clearDesktopDropHideTimer();
        });

        dropsWrapper.addEventListener('mouseleave', function () {
          scheduleDesktopDropHide(120);
        });
      }

      document.querySelectorAll('.mega-menu .mega-nav[data-tab]').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          var megaMenu = item.closest('.mega-menu');
          var tab = item.getAttribute('data-tab');
          if (!megaMenu || !tab) {
            return;
          }

          megaMenu.querySelectorAll('.mega-nav').forEach(function (navItem) {
            navItem.classList.toggle('active', navItem === item);
          });

          megaMenu.querySelectorAll('.mega-tab').forEach(function (panel) {
            var isActive = panel.getAttribute('data-tab') === tab;
            panel.classList.toggle('active', isActive);
            panel.style.display = isActive ? 'flex' : 'none';
          });
        });
      });

      var mobileNavCloseTimer = null;

      function setMobileMenuOpen(isOpen) {
        if (mobileNavCloseTimer) {
          window.clearTimeout(mobileNavCloseTimer);
          mobileNavCloseTimer = null;
        }

        var mobileNav = headerElement.querySelector('.nav-mobile');
        var activeToggle = headerElement.querySelector('.nav-toggle');

        if (isOpen) {
          document.body.classList.remove('nav-mobile-closing');
          document.body.classList.add('menu-open');
          document.body.style.overflowY = 'hidden';
          if (mobileNav) {
            mobileNav.removeAttribute('inert');
            mobileNav.setAttribute('aria-hidden', 'false');
            window.requestAnimationFrame(function () {
              var closeButton = mobileNav.querySelector('.btn-mav-close');
              if (closeButton) closeButton.focus();
            });
          }
        } else {
          document.body.classList.add('nav-mobile-closing');
          document.body.style.overflowY = 'visible';
          if (mobileNav) {
            mobileNav.setAttribute('inert', '');
            mobileNav.setAttribute('aria-hidden', 'true');
          }
          if (activeToggle) {
            activeToggle.focus();
          }
          mobileNavCloseTimer = window.setTimeout(function () {
            document.body.classList.remove('menu-open');
            document.body.classList.remove('nav-mobile-closing');
            mobileNavCloseTimer = null;
          }, 450);
        }

        var chatElement = document.querySelector('inbox-online-store-chat');
        if (chatElement) {
          chatElement.classList.toggle('extra', isOpen);
        }

        headerElement.querySelectorAll('.nav-toggle').forEach(function (toggle) {
          toggle.classList.toggle('active', isOpen);
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }

      document.querySelectorAll('.header .nav-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          setMobileMenuOpen(!document.body.classList.contains('menu-open'));
        });
      });

      document.querySelectorAll('.header .nav-mobile .btn-mav-close').forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          setMobileMenuOpen(false);
        });
      });

      document.querySelectorAll('.header .nav-mobile .nav-overlay').forEach(function (overlay) {
        overlay.addEventListener('click', function () {
          setMobileMenuOpen(false);
        });
      });

      document.querySelectorAll('.header .nav-mobile').forEach(function (mobileNav) {
        mobileNav.addEventListener('click', function (event) {
          var panelContent = event.target.closest('.inner-nav-content');
          var panelShell = event.target.closest('.main-nav-content');

          if (!panelContent && !panelShell) {
            setMobileMenuOpen(false);
          }
        });
      });

      function openMobileAccordionPanel(panel, buttonShell, toggleButton, accordionItem) {
        panel.classList.add('show');
        panel.style.display = 'block';
        panel.style.height = '0px';
        panel.style.opacity = '0';
        panel.style.overflow = 'hidden';

        window.requestAnimationFrame(function () {
          panel.style.height = panel.scrollHeight + 'px';
          panel.style.opacity = '1';
        });

        window.setTimeout(function () {
          if (panel.classList.contains('show')) {
            panel.style.height = 'auto';
            panel.style.overflow = '';
          }
        }, 360);

        toggleButton.setAttribute('aria-expanded', 'true');
        if (buttonShell) {
          buttonShell.classList.remove('collapsed');
        }
        if (accordionItem) {
          accordionItem.classList.add('is-open');
        }
      }

      function closeMobileAccordionPanel(panel, buttonShell, toggleButton, accordionItem) {
        if (!panel.classList.contains('show')) {
          return;
        }

        panel.style.height = panel.scrollHeight + 'px';
        panel.style.overflow = 'hidden';

        window.requestAnimationFrame(function () {
          panel.classList.remove('show');
          panel.style.height = '0px';
          panel.style.opacity = '0';
        });

        window.setTimeout(function () {
          if (!panel.classList.contains('show')) {
            panel.style.display = 'none';
            panel.style.overflow = '';
          }
        }, 360);

        toggleButton.setAttribute('aria-expanded', 'false');
        if (buttonShell) {
          buttonShell.classList.add('collapsed');
        }
        if (accordionItem) {
          accordionItem.classList.remove('is-open');
        }
      }

      document.querySelectorAll('.nav-mobile .accordion-toggle-button').forEach(function (button) {
        var accordionButtonShell = button.closest('.accordion-button');
        var accordionItem = button.closest('.accordion-item');
        var initialTargetSelector = button.getAttribute('data-bs-target');
        if (initialTargetSelector) {
          var initialTargetPanel = document.querySelector(initialTargetSelector);
          if (initialTargetPanel && initialTargetPanel.classList.contains('show')) {
            initialTargetPanel.style.display = 'block';
            initialTargetPanel.style.height = 'auto';
            initialTargetPanel.style.opacity = '1';
            if (accordionButtonShell) {
              accordionButtonShell.classList.remove('collapsed');
            }
            if (accordionItem) {
              accordionItem.classList.add('is-open');
            }
            button.setAttribute('aria-expanded', 'true');
          }
        }

        button.addEventListener('click', function (event) {
          event.preventDefault();

          var targetSelector = button.getAttribute('data-bs-target');
          if (!targetSelector) {
            return;
          }

          var targetPanel = document.querySelector(targetSelector);
          if (!targetPanel) {
            return;
          }

          var accordionContainer = button.closest('.accordion');
          var isOpen = targetPanel.classList.contains('show');

          if (accordionContainer) {
            accordionContainer.querySelectorAll('.accordion-collapse.show').forEach(function (panel) {
              if (panel !== targetPanel) {
                var siblingToggleButton = accordionContainer.querySelector('.accordion-toggle-button[data-bs-target="#' + panel.id + '"]');
                var siblingButtonShell = siblingToggleButton ? siblingToggleButton.closest('.accordion-button') : null;
                var siblingItem = siblingToggleButton ? siblingToggleButton.closest('.accordion-item') : null;
                if (siblingToggleButton) {
                  closeMobileAccordionPanel(panel, siblingButtonShell, siblingToggleButton, siblingItem);
                }
              }
            });
          }

          if (isOpen) {
            closeMobileAccordionPanel(targetPanel, accordionButtonShell, button, accordionItem);
          } else {
            openMobileAccordionPanel(targetPanel, accordionButtonShell, button, accordionItem);
          }
        });
      });

      if (!$) {
        document.addEventListener('click', function (event) {
          var trigger = event.target.closest('.mega-nav');
          if (!trigger) {
            return;
          }

          var megaMenu = trigger.closest('.mega-menu');
          if (!megaMenu) {
            return;
          }

          var tab = trigger.getAttribute('data-tab');
          if (!tab) {
            return;
          }

          megaMenu.querySelectorAll('.mega-nav').forEach(function (item) {
            item.classList.toggle('active', item === trigger);
          });

          megaMenu.querySelectorAll('.mega-tab').forEach(function (panel) {
            var isActive = panel.getAttribute('data-tab') === tab;
            panel.classList.toggle('active', isActive);
            panel.style.display = isActive ? 'flex' : 'none';
          });
        });
      }

      if (!$) {
        return;
      }

      $(document).on('click', '.icon-search', function (event) {
        var predictiveSearch = $('.predictive-search');
        if (!predictiveSearch.length) {
          return;
        }

        event.preventDefault();
        predictiveSearch.fadeIn();
        predictiveSearch.find('input[type="search"]').first().trigger('focus');
      });

      $(document).on('click', '.predictive-search .overlay, .predictive-search .icon-close', function () {
        $('.predictive-search').fadeOut();
        $('.predictive-search input').val('');
      });

      $(document).on('click', '#predictive-search .view-all', function () {
        $('predictive-search form').trigger('submit');
      });

    }

    function initIndexBanner() {
      var sections = document.querySelectorAll('.index-banner');

      sections.forEach(function (section) {
        var firstSlideContent = section.querySelector('.swiper-slide:first-child .index-banner__slide');
        if (firstSlideContent) {
          firstSlideContent.classList.remove('is-animated');

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              firstSlideContent.classList.add('is-animated');
            });
          });
        }
      });

      if (!window.Swiper) {
        return false;
      }

      sections.forEach(function (section) {
        var heightStyle = section.getAttribute('data-height-style');
        var container = section.querySelector('.index-banner-swiper');
        var enableLoop = section.getAttribute('data-enable-loop') === 'true';
        var enableAutoplay = section.getAttribute('data-enable-autoplay') === 'true';
        var autoplayDelay = parseInt(section.getAttribute('data-autoplay-delay'), 10) || 5;
        var enablePagination = section.getAttribute('data-enable-pagination') === 'true';
        var enableArrows = section.getAttribute('data-enable-arrows') === 'true';
        var slideCount = container ? container.querySelectorAll('.swiper-slide').length : 0;
        var prefersReducedMotion = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var isSmallScreen = window.matchMedia &&
          window.matchMedia('(max-width: 767.98px)').matches;

        if (!container) {
          return;
        }

        function resetSlideAnimations(swiperInstance) {
          swiperInstance.slides.forEach(function (slide) {
            var slideContent = slide.querySelector('.index-banner__slide');
            if (slideContent) {
              slideContent.classList.remove('is-animated');
            }
          });
        }

        function animateActiveSlide(swiperInstance) {
          resetSlideAnimations(swiperInstance);

          var activeSlides = [];

          if (swiperInstance.slides && swiperInstance.activeIndex != null) {
            activeSlides.push(swiperInstance.slides[swiperInstance.activeIndex]);
          }

          swiperInstance.slides.forEach(function (slide) {
            if (
              slide &&
              slide.classList.contains('swiper-slide-active') &&
              activeSlides.indexOf(slide) === -1
            ) {
              activeSlides.push(slide);
            }
          });

          activeSlides.forEach(function (slide) {
            if (!slide) {
              return;
            }

            var slideContent = slide.querySelector('.index-banner__slide');
            if (!slideContent) {
              return;
            }

            window.setTimeout(function () {
              slideContent.classList.add('is-animated');
            }, 40);
          });
        }

        var bannerSwiper = new window.Swiper(container, {
          loop: enableLoop && slideCount > 1,
          speed: 600,
          autoHeight: heightStyle === 'adaptive',
          effect: 'slide',
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          autoplay: enableAutoplay && slideCount > 1 && !prefersReducedMotion && !isSmallScreen
            ? {
                delay: autoplayDelay * 1000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }
            : false,
          pagination: enablePagination
            ? {
                el: section.querySelector('.swiper-pagination'),
                clickable: true
              }
            : false,
          navigation: enableArrows
            ? {
                prevEl: section.querySelector('.index-banner__arrow--prev'),
                nextEl: section.querySelector('.index-banner__arrow--next')
              }
            : false,
          on: {
            init: function () {
              animateActiveSlide(this);
            },
            slideChangeTransitionStart: function () {
              resetSlideAnimations(this);
            },
            slideChangeTransitionEnd: function () {
              animateActiveSlide(this);
            }
          }
        });

        if (heightStyle === 'adaptive') {
          window.addEventListener('load', function () {
            bannerSwiper.updateAutoHeight(0);
          });
        }
      });

      return true;
    }

    function initBackToTop() {
      var backToTopButton = document.querySelector('.nolters-footer__backtop');

      if (!backToTopButton) {
        return;
      }

      function updateBackToTopVisibility() {
        var currentScrollY = Math.max(window.pageYOffset || window.scrollY || 0, 0);
        backToTopButton.classList.toggle('is-visible', currentScrollY >= 1000);
      }

      backToTopButton.addEventListener('click', function (event) {
        event.preventDefault();

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });

      updateBackToTopVisibility();
      window.addEventListener('scroll', updateBackToTopVisibility);
    }

    function initReviewsSliders() {
      var sliders = document.querySelectorAll('[data-reviews-slider]');

      if (!sliders.length || !window.Swiper) {
        return false;
      }

      function getJudgeMeRating(reviewElement) {
        var ratingElement = reviewElement.querySelector('.jdgm-rev__rating');
        var rating = ratingElement ? parseFloat(ratingElement.getAttribute('data-score')) : NaN;

        if (isNaN(rating) && ratingElement) {
          rating = ratingElement.querySelectorAll('.jdgm-star.jdgm--on').length;
        }

        if (isNaN(rating) || rating < 1) {
          return 5;
        }

        return Math.max(1, Math.min(5, Math.round(rating)));
      }

      function formatReviewDate(value) {
        var rawValue = (value || '').trim();
        var dateMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/);
        var date = dateMatch
          ? new Date(dateMatch[0].length > 10 ? rawValue : Date.UTC(Number(dateMatch[1]), Number(dateMatch[2]) - 1, Number(dateMatch[3])))
          : new Date(rawValue);

        if (isNaN(date.getTime())) {
          return rawValue;
        }

        var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        var hours = date.getUTCHours();
        var minutes = String(date.getUTCMinutes()).padStart(2, '0');
        var meridiem = hours >= 12 ? 'PM' : 'AM';
        var displayHours = hours % 12 || 12;
        return monthNames[date.getUTCMonth()] + ' ' + date.getUTCDate() + ', ' + date.getUTCFullYear() + ' at ' + displayHours + ':' + minutes + ' ' + meridiem;
      }

      function getJudgeMeReviewData(reviewElement) {
        var authorElement = reviewElement.querySelector('.jdgm-rev__author');
        var dateElement = reviewElement.querySelector('.jdgm-rev__timestamp');
        var bodyElement = reviewElement.querySelector('.jdgm-rev__body');
        var imageLinkElements = reviewElement.querySelectorAll('.jdgm-rev__pic-link');
        var imageElements = reviewElement.querySelectorAll(
          '.jdgm-rev__pics img, .jdgm-rev__pic-list img, .jdgm-rev__pic-link img'
        );
        var images = [];

        imageLinkElements.forEach(function (linkElement) {
          var imageUrl = linkElement.getAttribute('href');

          if (imageUrl && images.indexOf(imageUrl) === -1) {
            images.push(imageUrl);
          }
        });

        imageElements.forEach(function (imageElement) {
          if (imageElement.closest('.jdgm-rev__pic-link')) {
            return;
          }

          var imageUrl =
            imageElement.currentSrc ||
            imageElement.getAttribute('src') ||
            imageElement.getAttribute('data-src');

          if (imageUrl && images.indexOf(imageUrl) === -1) {
            images.push(imageUrl);
          }
        });

        return {
          author: authorElement ? authorElement.textContent.trim() : '',
          date: dateElement
            ? formatReviewDate(dateElement.getAttribute('data-content') || dateElement.textContent.trim())
            : '',
          body: bodyElement ? bodyElement.textContent.trim() : '',
          rating: getJudgeMeRating(reviewElement),
          images: images.slice(0, 4)
        };
      }

      function getCurrentProductReviewElements(source) {
        var productUrl = source ? source.getAttribute('data-product-url') : '';

        return source
          ? Array.prototype.slice.call(source.querySelectorAll('.jdgm-rev')).filter(function (review) {
              var reviewProductUrl = review.getAttribute('data-product-url');
              return !productUrl || !reviewProductUrl || reviewProductUrl === productUrl;
            })
          : [];
      }

      function fetchJudgeMePageReviews(source, pageNumber) {
        var pagination = source
          ? source.querySelector('.jdgm-paginate[data-url]')
          : null;
        var endpoint = pagination ? pagination.getAttribute('data-url') : '';
        var shopDomain = source ? source.getAttribute('data-shop-domain') : '';
        var productId = source ? source.getAttribute('data-id') : '';
        var perPage = parseInt(
          pagination ? pagination.getAttribute('data-per-page') : '5',
          10
        ) || 5;

        if (!endpoint || !shopDomain || !productId) {
          return Promise.reject(new Error('Judge.me pagination data is unavailable.'));
        }

        var requestUrl = new URL(endpoint);
        requestUrl.searchParams.set('url', shopDomain);
        requestUrl.searchParams.set('shop_domain', shopDomain);
        requestUrl.searchParams.set('platform', 'shopify');
        requestUrl.searchParams.set('page', pageNumber);
        requestUrl.searchParams.set('per_page', perPage);
        requestUrl.searchParams.set('product_id', productId);

        return window
          .fetch(requestUrl.toString(), { credentials: 'omit' })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Judge.me returned ' + response.status + '.');
            }

            return response.json();
          })
          .then(function (payload) {
            var template = document.createElement('template');
            template.innerHTML = payload && payload.html ? payload.html : '';

            return Array.prototype.slice
              .call(template.content.querySelectorAll('.jdgm-rev'))
              .map(getJudgeMeReviewData)
              .filter(function (review) {
                return Boolean(review.body || review.images.length);
              });
          });
      }

      function createReviewCard(review) {
        var card = document.createElement('article');
        var stars = document.createElement('div');
        var index;

        if (!review.body && !review.images.length) {
          return null;
        }

        card.className = 'reviews-slider-section__card';
        stars.className = 'reviews-slider-section__stars';
        stars.setAttribute('aria-label', review.rating + ' out of 5 stars');

        for (index = 1; index <= 5; index += 1) {
          var star = document.createElement('span');
          star.className =
            'reviews-slider-section__star' + (index > review.rating ? ' is-empty' : '');
          star.textContent = '\u2605';
          stars.appendChild(star);
        }

        card.appendChild(stars);

        if (review.author) {
          var authorNode = document.createElement('p');
          authorNode.className = 'reviews-slider-section__author';
          authorNode.textContent = review.author;
          card.appendChild(authorNode);
        }

        if (review.date) {
          var dateNode = document.createElement('time');
          dateNode.className = 'reviews-slider-section__date';
          dateNode.textContent = review.date;
          card.appendChild(dateNode);
        }

        if (review.body) {
          var bodyNode = document.createElement('div');
          bodyNode.className = 'reviews-slider-section__review';
          bodyNode.textContent = review.body;
          card.appendChild(bodyNode);
        }

        if (review.images.length) {
          var imagesNode = document.createElement('div');
          imagesNode.className = 'reviews-slider-section__images';

          review.images.forEach(function (imageUrl) {
            var imageButton = document.createElement('button');
            var imageNode = document.createElement('img');

            imageButton.type = 'button';
            imageButton.className = 'reviews-slider-section__image-button';
            imageButton.setAttribute('data-review-media-url', imageUrl);
            imageButton.setAttribute(
              'aria-label',
              review.author ? 'Open review image from ' + review.author : 'Open customer review image'
            );
            imageNode.className = 'reviews-slider-section__image';
            imageNode.src = imageUrl;
            imageNode.alt = review.author ? 'Review image from ' + review.author : 'Customer review image';
            imageNode.loading = 'lazy';
            imageButton.appendChild(imageNode);
            imagesNode.appendChild(imageButton);
          });

          card.appendChild(imagesNode);
        }

        return card;
      }

      function createJudgeMeSlide(review) {
        var slide = document.createElement('div');
        var card = createReviewCard(review);

        if (!card) {
          return null;
        }

        slide.className = 'swiper-slide';
        slide.appendChild(card);

        return slide;
      }

      function setupReviewMediaDialog(sliderSection) {
        var dialog = sliderSection.querySelector('[data-review-media-dialog]');
        var image = sliderSection.querySelector('[data-review-media-image]');
        var caption = sliderSection.querySelector('[data-review-media-caption]');
        var closeButton = sliderSection.querySelector('[data-review-media-close]');

        if (!dialog || !image || !caption || !closeButton || dialog.getAttribute('data-media-bound') === 'true') {
          return;
        }

        var trigger = null;

        function closeMediaDialog() {
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        sliderSection.addEventListener('click', function (event) {
          var imageButton = event.target.closest('[data-review-media-url]');

          if (!imageButton || !sliderSection.contains(imageButton)) {
            return;
          }

          trigger = imageButton;
          image.src = imageButton.getAttribute('data-review-media-url');
          image.alt = imageButton.getAttribute('aria-label') || 'Customer review image';
          caption.textContent = imageButton.getAttribute('aria-label') || '';
          caption.hidden = !caption.textContent;

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });

        closeButton.addEventListener('click', closeMediaDialog);
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) {
            closeMediaDialog();
          }
        });
        dialog.addEventListener('close', function () {
          image.removeAttribute('src');

          if (trigger) {
            trigger.focus();
          }
        });
        dialog.setAttribute('data-media-bound', 'true');
      }

      function setupJudgeMeDialog(sliderSection, reviews, source, totalReviews) {
        var dialog = sliderSection.querySelector('[data-reviews-dialog]');
        var openButton = sliderSection.querySelector('[data-reviews-view-all]');
        var closeButton = sliderSection.querySelector('[data-reviews-dialog-close]');
        var previousButton = sliderSection.querySelector('[data-reviews-page-previous]');
        var nextButton = sliderSection.querySelector('[data-reviews-page-next]');
        var list = sliderSection.querySelector('[data-reviews-dialog-list]');
        var pages = sliderSection.querySelector('[data-reviews-pages]');
        var lockedPageScrollTop = 0;
        var pageScrollIsLocked = false;
        var originalBodyStyles = {};
        var originalDocumentOverflow = '';

        if (!dialog || !openButton || !list || !pages) {
          return;
        }

        function lockPageScroll() {
          if (pageScrollIsLocked) {
            return;
          }

          lockedPageScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
          originalDocumentOverflow = document.documentElement.style.overflow;
          originalBodyStyles = {
            position: document.body.style.position,
            top: document.body.style.top,
            left: document.body.style.left,
            right: document.body.style.right,
            width: document.body.style.width,
            overflow: document.body.style.overflow
          };

          document.documentElement.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + lockedPageScrollTop + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
          document.body.style.overflow = 'hidden';
          pageScrollIsLocked = true;
        }

        function unlockPageScroll() {
          if (!pageScrollIsLocked) {
            return;
          }

          document.documentElement.style.overflow = originalDocumentOverflow;
          document.body.style.position = originalBodyStyles.position;
          document.body.style.top = originalBodyStyles.top;
          document.body.style.left = originalBodyStyles.left;
          document.body.style.right = originalBodyStyles.right;
          document.body.style.width = originalBodyStyles.width;
          document.body.style.overflow = originalBodyStyles.overflow;
          pageScrollIsLocked = false;
          window.scrollTo(0, lockedPageScrollTop);
        }

        var currentSourcePageElement = source
          ? source.querySelector('.jdgm-paginate__page.jdgm-curt')
          : null;
        var currentSourcePage = parseInt(
          currentSourcePageElement ? currentSourcePageElement.getAttribute('data-page') : '1',
          10
        ) || 1;
        var popupPageSize = parseInt(dialog.getAttribute('data-reviews-per-page'), 10) || 5;
        var sourcePageSize = reviews.length || 5;
        var lastPageElement = source
          ? source.querySelector('.jdgm-paginate__last-page')
          : null;
        var sourcePageCount = parseInt(
          lastPageElement ? lastPageElement.getAttribute('data-page') : '',
          10
        ) || Math.max(1, Math.ceil(Math.max(totalReviews, reviews.length) / sourcePageSize));
        var popupPageCount = Math.max(
          1,
          Math.ceil(Math.max(totalReviews, reviews.length) / popupPageSize)
        );
        var state = sliderSection.judgeMeDialogState || {
          sourcePages: {},
          pageCount: popupPageCount,
          currentPage: currentSourcePage,
          source: source,
          totalReviews: totalReviews
        };

        state.sourcePages = state.sourcePages || state.pages || {};
        state.pageCount = popupPageCount;
        state.popupPageSize = popupPageSize;
        state.sourcePageSize = sourcePageSize;
        state.sourcePageCount = sourcePageCount;
        state.source = source;
        state.totalReviews = totalReviews;
        if (sliderSection.judgeMeSliderLoadState) {
          Object.keys(sliderSection.judgeMeSliderLoadState.sourcePages).forEach(function (
            sourcePage
          ) {
            state.sourcePages[sourcePage] =
              sliderSection.judgeMeSliderLoadState.sourcePages[sourcePage];
          });
        }
        state.sourcePages[currentSourcePage] = reviews;
        state.ratingTotals = {};
        state.source.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (row) {
          var rating = parseInt(row.getAttribute('data-rating'), 10);
          var frequency = row.querySelector('.jdgm-histogram__frequency');
          var total = parseInt(
            frequency ? frequency.textContent.replace(/[^\d]/g, '') : '',
            10
          );

          if (rating >= 1 && rating <= 5 && !isNaN(total)) {
            state.ratingTotals[rating] = total;
          }
        });
        sliderSection.judgeMeDialogState = state;

        function getLoadedReviews() {
          return Object.keys(state.sourcePages)
            .map(function (sourcePage) {
              return parseInt(sourcePage, 10);
            })
            .sort(function (firstPage, secondPage) {
              return firstPage - secondPage;
            })
            .reduce(function (loadedReviews, sourcePage) {
              return loadedReviews.concat(state.sourcePages[sourcePage] || []);
            }, []);
        }

        function getRequiredRatingCounts(popupPage) {
          var reviewsNeeded = Math.min(
            popupPage * state.popupPageSize,
            state.totalReviews
          );
          var requiredCounts = {};
          var rating;

          for (rating = 5; rating >= 1; rating -= 1) {
            requiredCounts[rating] = Math.min(
              state.ratingTotals[rating] || 0,
              reviewsNeeded
            );
            reviewsNeeded -= requiredCounts[rating];
          }

          return requiredCounts;
        }

        function hasEnoughReviewsForPage(popupPage) {
          var requiredCounts = getRequiredRatingCounts(popupPage);
          var loadedCounts = {};

          getLoadedReviews().forEach(function (review) {
            loadedCounts[review.rating] = (loadedCounts[review.rating] || 0) + 1;
          });

          return Object.keys(requiredCounts).every(function (rating) {
            return (loadedCounts[rating] || 0) >= requiredCounts[rating];
          });
        }

        function getNextUnloadedSourcePage() {
          var sourcePage;

          for (sourcePage = 1; sourcePage <= state.sourcePageCount; sourcePage += 1) {
            if (!state.sourcePages[sourcePage]) {
              return sourcePage;
            }
          }

          return null;
        }

        function getPopupPageReviews(popupPage) {
          var startIndex = (popupPage - 1) * state.popupPageSize;

          return getLoadedReviews()
            .sort(function (firstReview, secondReview) {
              return secondReview.rating - firstReview.rating;
            })
            .slice(startIndex, startIndex + state.popupPageSize);
        }

        function renderPage(pageNumber) {
          var currentPage = Math.max(1, Math.min(state.pageCount, pageNumber));
          var currentReviews = getPopupPageReviews(currentPage);
          var fragment = document.createDocumentFragment();
          var pageFragment = document.createDocumentFragment();
          var pageNumbers = [1, currentPage - 1, currentPage, currentPage + 1, state.pageCount]
            .filter(function (page, index, values) {
              return page >= 1 && page <= state.pageCount && values.indexOf(page) === index;
            })
            .sort(function (firstPage, secondPage) {
              return firstPage - secondPage;
            });
          var previousRenderedPage = 0;

          currentReviews.forEach(function (review) {
            var reviewWrapper = document.createElement('div');
            var card = createReviewCard(review);

            if (card) {
              reviewWrapper.className = 'reviews-slider-section__dialog-review';
              reviewWrapper.appendChild(card);
              fragment.appendChild(reviewWrapper);
            }
          });

          pageNumbers.forEach(function (page) {
            if (previousRenderedPage && page - previousRenderedPage > 1) {
              var ellipsis = document.createElement('span');
              ellipsis.className = 'reviews-slider-section__dialog-ellipsis';
              ellipsis.textContent = '\u2026';
              pageFragment.appendChild(ellipsis);
            }

            var pageButton = document.createElement('button');
            pageButton.type = 'button';
            pageButton.textContent = page;
            pageButton.setAttribute('aria-label', 'Review page ' + page);
            pageButton.classList.toggle('is-current', page === currentPage);
            pageButton.setAttribute('aria-current', page === currentPage ? 'page' : 'false');
            pageButton.addEventListener('click', function (event) {
              loadPage(parseInt(event.currentTarget.textContent, 10));
            });
            pageFragment.appendChild(pageButton);
            previousRenderedPage = page;
          });

          list.replaceChildren(fragment);
          pages.replaceChildren(pageFragment);
          previousButton.disabled = currentPage === 1;
          nextButton.disabled = currentPage === state.pageCount;
          previousButton.setAttribute('data-target-page', currentPage - 1);
          nextButton.setAttribute('data-target-page', currentPage + 1);
          dialog.setAttribute('data-current-page', currentPage);
          state.currentPage = currentPage;
          dialog.querySelector('.reviews-slider-section__dialog-panel').scrollTop = 0;
        }

        function loadPage(pageNumber) {
          var targetPage = Math.max(1, Math.min(state.pageCount, pageNumber));
          var missingSourcePage = getNextUnloadedSourcePage();

          if (hasEnoughReviewsForPage(targetPage) || !missingSourcePage) {
            renderPage(targetPage);
            return;
          }

          if (state.requestedSourcePage) {
            return;
          }

          list.textContent = 'Loading reviews\u2026';
          state.pendingPopupPage = targetPage;
          state.requestedSourcePage = missingSourcePage;

          fetchJudgeMePageReviews(state.source, missingSourcePage)
            .then(function (updatedReviews) {
              state.sourcePages[missingSourcePage] = updatedReviews;
              state.requestedSourcePage = null;

              if (dialog.open || dialog.hasAttribute('open')) {
                loadPage(state.pendingPopupPage || 1);
              }
            })
            .catch(function () {
              state.requestedSourcePage = null;
              list.textContent = 'Reviews could not be loaded. Please try again.';
            });
        }

        if (dialog.getAttribute('data-dialog-bound') !== 'true') {
          openButton.addEventListener('click', function (event) {
            event.preventDefault();
            openButton.blur();
            lockPageScroll();

            if (typeof dialog.showModal === 'function') {
              dialog.showModal();
            } else {
              dialog.setAttribute('open', '');
            }

            dialog.setAttribute('tabindex', '-1');
            dialog.focus({ preventScroll: true });

            loadPage(1);
          });

          closeButton.addEventListener('click', function () {
            if (typeof dialog.close === 'function') {
              dialog.close();
            } else {
              dialog.removeAttribute('open');
              unlockPageScroll();
            }
          });

          previousButton.addEventListener('click', function () {
            loadPage(parseInt(previousButton.getAttribute('data-target-page'), 10));
          });

          nextButton.addEventListener('click', function () {
            loadPage(parseInt(nextButton.getAttribute('data-target-page'), 10));
          });

          dialog.addEventListener('click', function (event) {
            if (event.target === dialog) {
              if (typeof dialog.close === 'function') {
                dialog.close();
              } else {
                dialog.removeAttribute('open');
                unlockPageScroll();
              }
            }
          });

          dialog.addEventListener('close', unlockPageScroll);
          dialog.setAttribute('data-dialog-bound', 'true');
        }
      }

      function syncJudgeMeReviews(sliderElement) {
        if (sliderElement.getAttribute('data-reviews-source') !== 'judge-me') {
          return true;
        }

        if (sliderElement.getAttribute('data-judge-me-synced') === 'true') {
          return true;
        }

        var sliderSection = sliderElement.closest('[data-judge-me-reviews-section]');
        var source = sliderSection
          ? sliderSection.querySelector('[data-judge-me-reviews-source]')
          : null;
        var track = sliderElement.querySelector('[data-reviews-slider-track]');
        var limit = parseInt(sliderElement.getAttribute('data-reviews-limit'), 10) || 10;
        var reviewElements = getCurrentProductReviewElements(source);
        var reviews = reviewElements.map(getJudgeMeReviewData).filter(function (review) {
          return Boolean(review.body || review.images.length);
        });
        var widget = source ? source.querySelector('.jdgm-rev-widg') : null;
        var totalReviews = parseInt(
          widget ? widget.getAttribute('data-number-of-reviews') : '',
          10
        ) || reviews.length;
        var currentPageElement = source
          ? source.querySelector('.jdgm-paginate__page.jdgm-curt')
          : null;
        var currentPage = parseInt(
          currentPageElement ? currentPageElement.getAttribute('data-page') : '1',
          10
        ) || 1;
        var lastPageElement = source
          ? source.querySelector('.jdgm-paginate__last-page')
          : null;
        var sourcePageCount = parseInt(
          lastPageElement ? lastPageElement.getAttribute('data-page') : '',
          10
        ) || Math.max(1, Math.ceil(totalReviews / Math.max(reviews.length, 1)));
        var sliderLoadState = sliderSection.judgeMeSliderLoadState || {
          sourcePages: {},
          pendingSourcePage: null,
          failedSourcePages: {}
        };

        sliderLoadState.failedSourcePages = sliderLoadState.failedSourcePages || {};
        sliderLoadState.sourcePages[currentPage] = reviews;
        sliderSection.judgeMeSliderLoadState = sliderLoadState;

        var loadedSliderReviews = Object.keys(sliderLoadState.sourcePages)
          .map(function (sourcePage) {
            return parseInt(sourcePage, 10);
          })
          .sort(function (firstPage, secondPage) {
            return firstPage - secondPage;
          })
          .reduce(function (loadedReviews, sourcePage) {
            return loadedReviews.concat(sliderLoadState.sourcePages[sourcePage] || []);
          }, []);
        var sliderReviews = loadedSliderReviews.filter(function (review) {
          return review.rating === 5;
        });
        var nextUnloadedSourcePage = null;
        var sourcePage;

        if (sliderReviews.length < limit) {
          for (sourcePage = 1; sourcePage <= sourcePageCount; sourcePage += 1) {
            if (
              !sliderLoadState.sourcePages[sourcePage] &&
              !sliderLoadState.failedSourcePages[sourcePage]
            ) {
              nextUnloadedSourcePage = sourcePage;
              break;
            }
          }
        }

        if (nextUnloadedSourcePage && !sliderLoadState.pendingSourcePage) {
          if (
            sliderElement.getAttribute('data-judge-me-load-visible') !== 'true' &&
            window.IntersectionObserver
          ) {
            if (!sliderLoadState.visibilityObserver) {
              sliderLoadState.visibilityObserver = new window.IntersectionObserver(
                function (entries) {
                  if (!entries.some(function (entry) { return entry.isIntersecting; })) {
                    return;
                  }

                  sliderLoadState.visibilityObserver.disconnect();
                  sliderLoadState.visibilityObserver = null;
                  sliderElement.setAttribute('data-judge-me-load-visible', 'true');
                  initReviewsSliders();
                },
                { rootMargin: '0px', threshold: 0.15 }
              );
              sliderLoadState.visibilityObserver.observe(sliderSection);
            }

            return false;
          }

          sliderLoadState.pendingSourcePage = nextUnloadedSourcePage;
          fetchJudgeMePageReviews(source, nextUnloadedSourcePage)
            .then(function (pageReviews) {
              sliderLoadState.sourcePages[nextUnloadedSourcePage] = pageReviews;
              sliderLoadState.pendingSourcePage = null;
              initReviewsSliders();
            })
            .catch(function () {
              sliderLoadState.failedSourcePages[nextUnloadedSourcePage] = true;
              sliderLoadState.pendingSourcePage = null;
              initReviewsSliders();
            });
          return false;
        }

        var fragment = document.createDocumentFragment();
        var addedReviews = 0;

        sliderReviews.some(function (review) {
          var slide = createJudgeMeSlide(review);

          if (!slide) {
            return false;
          }

          fragment.appendChild(slide);
          addedReviews += 1;
          return addedReviews >= limit;
        });

        if (!track || !addedReviews) {
          var noProductReviewsDisplay =
            sliderSection.getAttribute('data-no-product-reviews-display') || 'hide';
          var fallbackSlides = track
            ? track.querySelectorAll('[data-store-review-slide]')
            : [];
          var useStoreReviews =
            totalReviews === 0 &&
            noProductReviewsDisplay === 'store_reviews' &&
            fallbackSlides.length > 0;
          var emptyMessage = sliderSection.querySelector('[data-reviews-empty]');
          var fallbackNote = sliderSection.querySelector('[data-reviews-fallback-note]');

          if (useStoreReviews) {
            sliderSection.hidden = false;
            sliderElement.setAttribute('data-judge-me-synced', 'true');
            emptyMessage.hidden = true;
            fallbackNote.hidden = false;
            sliderSection.querySelector('[data-reviews-summary]').hidden = true;
            sliderSection.querySelectorAll('[data-reviews-content]').forEach(function (element) {
              element.hidden = false;
            });
            return true;
          }

          sliderSection.hidden =
            totalReviews === 0 && noProductReviewsDisplay === 'hide';
          emptyMessage.textContent = totalReviews === 0
            ? 'No reviews for this product yet.'
            : 'No reviews displayed.';
          emptyMessage.hidden = sliderSection.hidden;
          fallbackNote.hidden = true;
          sliderSection.querySelector('[data-reviews-summary]').hidden = true;
          sliderSection.querySelectorAll('[data-reviews-content]').forEach(function (element) {
            element.hidden = true;
          });

          if (source && !source.judgeMeReviewObserver && window.MutationObserver) {
            source.judgeMeReviewObserver = new window.MutationObserver(function () {
              if (source.querySelector('.jdgm-rev')) {
                source.judgeMeReviewObserver.disconnect();
                source.judgeMeReviewObserver = null;
                initReviewsSliders();
              }
            });
            source.judgeMeReviewObserver.observe(source, { childList: true, subtree: true });
          }

          return false;
        }

        sliderSection.hidden = false;
        track.replaceChildren(fragment);
        sliderElement.setAttribute('data-judge-me-synced', 'true');

        if (source.judgeMeReviewObserver) {
          source.judgeMeReviewObserver.disconnect();
          source.judgeMeReviewObserver = null;
        }

        sliderSection.querySelector('[data-reviews-count]').textContent = totalReviews;
        sliderSection.querySelector('[data-reviews-count-label]').textContent =
          totalReviews === 1 ? 'review' : 'reviews';
        sliderSection.querySelector('[data-reviews-empty]').hidden = true;
        sliderSection.querySelector('[data-reviews-summary]').hidden = false;
        sliderSection.querySelectorAll('[data-reviews-content]').forEach(function (element) {
          element.hidden = false;
        });
        setupReviewMediaDialog(sliderSection);
        setupJudgeMeDialog(sliderSection, reviews, source, totalReviews);
        return true;
      }

      sliders.forEach(function (sliderElement) {
        if (!syncJudgeMeReviews(sliderElement)) {
          return;
        }

        var sliderSection = sliderElement.closest('.reviews-slider-section');
        var sliderWrap = sliderElement.closest('.reviews-slider-section__slider-wrap');
        var controlsScope = sliderWrap || sliderSection || sliderElement;
        var enableLoop = sliderElement.getAttribute('data-enable-loop') === 'true';
        var enableAutoplay = sliderElement.getAttribute('data-enable-autoplay') === 'true';
        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;

        function updateReviewCards(swiperInstance) {
          swiperInstance.slides.forEach(function (slide) {
            var card = slide.querySelector('.reviews-slider-section__card');
            if (!card) {
              return;
            }

            var isActive =
              slide.classList.contains('swiper-slide-active') ||
              slide.classList.contains('swiper-slide-next') ||
              slide.classList.contains('swiper-slide-prev');

            card.classList.toggle('is-active', isActive);
          });
        }

        function updateReviewSliderHeight(swiperInstance, speed) {
          if (!swiperInstance || typeof swiperInstance.updateAutoHeight !== 'function') {
            return;
          }

          window.requestAnimationFrame(function () {
            swiperInstance.updateAutoHeight(typeof speed === 'number' ? speed : 300);
          });
        }

        if (sliderElement.swiper) {
          sliderElement.swiper.destroy(true, true);
        }

        new window.Swiper(sliderElement, {
          loop: enableLoop && slideCount > 1,
          slidesPerView: 1.04,
          spaceBetween: 20,
          speed: 650,
          autoHeight: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoplay: enableAutoplay
            ? {
                delay: 4500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }
            : false,
          navigation: {
            prevEl: controlsScope.querySelector('.reviews-slider-section__nav--prev'),
            nextEl: controlsScope.querySelector('.reviews-slider-section__nav--next')
          },
          pagination: {
            el: controlsScope.querySelector('.reviews-slider-section__pagination'),
            type: 'progressbar'
          },
          on: {
            init: function () {
              updateReviewCards(this);
              updateReviewSliderHeight(this, 0);
            },
            slideChangeTransitionStart: function () {
              updateReviewCards(this);
              updateReviewSliderHeight(this, 650);
            },
            slideChangeTransitionEnd: function () {
              updateReviewCards(this);
              updateReviewSliderHeight(this, 0);
            },
            imagesReady: function () {
              updateReviewSliderHeight(this, 0);
            },
            resize: function () {
              updateReviewSliderHeight(this, 0);
            },
            breakpoint: function () {
              updateReviewSliderHeight(this, 0);
            }
          },
          breakpoints: {
            768: {
              slidesPerView: 1.85,
              spaceBetween: 24
            },
            1200: {
              slidesPerView: 2.15,
              spaceBetween: 32
            }
          }
        });
      });

      return true;
    }

    function initCollectionProductSliders() {
      var sliders = document.querySelectorAll('[data-collection-products-slider]');

      if (!sliders.length || !window.Swiper) {
        return false;
      }

      sliders.forEach(function (sliderElement) {
        var section = sliderElement.closest('.collection-products-slider');
        var enableLoop = sliderElement.getAttribute('data-enable-loop') === 'true';
        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;

        if (!section) {
          return;
        }

        if (sliderElement.swiper) {
          sliderElement.swiper.destroy(true, true);
        }

        new window.Swiper(sliderElement, {
          loop: enableLoop && slideCount > 1,
          slidesPerView: 1.2,
          spaceBetween: 18,
          speed: 650,
          watchOverflow: true,
          navigation: {
            prevEl: section.querySelector('.collection-products-slider__nav--prev'),
            nextEl: section.querySelector('.collection-products-slider__nav--next')
          },
          pagination: {
            el: section.querySelector('.collection-products-slider__pagination'),
            type: 'progressbar'
          },
          breakpoints: {
            768: {
              slidesPerView: 2.3,
              spaceBetween: 18
            },
            990: {
              slidesPerView: 4,
              spaceBetween: 18
            }
          }
        });
      });

      return true;
    }

    function initCartDrawer() {
      var drawer = document.querySelector('[data-cart-drawer]');
      var cartPageForm = document.querySelector('.main-cart-page__layout');
      var productPopup = document.querySelector('[data-product-popup]');

      function validatePolicy(container) {
        if (!container) {
          return true;
        }

        var checkbox = container.querySelector('[data-cart-policy-checkbox]');
        var error = container.querySelector('[data-cart-policy-error]');

        if (!checkbox) {
          return true;
        }

        var isValid = checkbox.checked;

        if (error) {
          error.hidden = isValid;
        }

        return isValid;
      }

      if (cartPageForm) {
        cartPageForm.addEventListener('submit', function (event) {
          var submitter = event.submitter;
          if (!submitter || submitter.name !== 'checkout') {
            return;
          }

          if (!validatePolicy(cartPageForm)) {
            event.preventDefault();
          }
        });

        var cartPageCheckbox = cartPageForm.querySelector('[data-cart-policy-checkbox]');
        var cartPageError = cartPageForm.querySelector('[data-cart-policy-error]');

        if (cartPageCheckbox && cartPageError) {
          cartPageCheckbox.addEventListener('change', function () {
            cartPageError.hidden = cartPageCheckbox.checked;
          });
        }
      }

      if (!drawer) {
        return;
      }

      var panel = drawer.querySelector('.cart-drawer__panel');
      var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
      var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
      var subtotalElement = drawer.querySelector('[data-cart-subtotal]');
      var checkoutButton = drawer.querySelector('[data-cart-checkout]');
      var cartNoteInput = drawer.querySelector('[data-cart-note]');
      var cartNoteStatus = drawer.querySelector('[data-cart-note-status]');
      var rootPath =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      var cartUrl = rootPath + 'cart.js';
      var cartChangeUrl = rootPath + 'cart/change.js';
      var cartUpdateUrl = rootPath + 'cart/update.js';
      var isLoading = false;
      var noteSaveTimer = null;
      var lastSavedNote = cartNoteInput ? cartNoteInput.value : '';
      var popupProduct = null;
      var popupVariant = null;
      var popupSelections = [];

      function formatMoney(cents, currency) {
        var amount = Number(cents || 0) / 100;
        return amount.toLocaleString('en-US', {
          style: 'currency',
          currency: currency || 'USD'
        });
      }

      function updateCartDots(itemCount) {
        document.querySelectorAll('.icon-cart .dot').forEach(function (dot) {
          if (itemCount > 0) {
            dot.style.display = 'flex';
            dot.textContent = itemCount;
          } else {
            dot.style.display = 'none';
            dot.textContent = '0';
          }
        });
      }

      function buildCartItem(item, index, currency) {
        var itemUrl = item.url || '#';
        var title = item.product_title || item.title || 'Product';
        var variantTitle =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
            : '';
        var propertiesMarkup = Object.keys(item.properties || {})
          .filter(function (key) {
            return key.charAt(0) !== '_' && item.properties[key] !== '' && item.properties[key] != null;
          })
          .map(function (key) {
            var escapeHtml = function (value) {
              return String(value).replace(/[&<>"']/g, function (character) {
                return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character];
              });
            };

            return '<p class="cart-drawer__item-property">' +
              escapeHtml(key) + ': ' + escapeHtml(item.properties[key]) + '</p>';
          })
          .join('');
        var imageMarkup = item.featured_image && item.featured_image.url
          ? '<img class="cart-drawer__item-image" src="' +
            item.featured_image.url +
            '&width=320" alt="' +
            title.replace(/"/g, '&quot;') +
            '" loading="lazy">'
          : '<div class="cart-drawer__item-placeholder"></div>';

        return (
          '<article class="cart-drawer__item" data-cart-line="' +
          (index + 1) +
          '">' +
          '<a href="' +
          itemUrl +
          '" class="cart-drawer__item-media">' +
          imageMarkup +
          '</a>' +
          '<div class="cart-drawer__item-content">' +
          '<div class="cart-drawer__item-top">' +
          '<a href="' +
          itemUrl +
          '" class="cart-drawer__item-title">' +
          title +
          '</a>' +
          '<button type="button" class="cart-drawer__remove" data-cart-remove data-line="' +
          (index + 1) +
          '" aria-label="Remove ' +
          title.replace(/"/g, '&quot;') +
          '">Remove</button>' +
          '</div>' +
          variantTitle +
          propertiesMarkup +
          '<div class="cart-drawer__item-bottom">' +
          '<div class="cart-drawer__quantity">' +
          '<button type="button" class="cart-drawer__qty-button" data-cart-quantity-change data-line="' +
          (index + 1) +
          '" data-quantity="' +
          Math.max(item.quantity - 1, 0) +
          '" aria-label="Decrease quantity">-</button>' +
          '<span class="cart-drawer__qty-value">' +
          item.quantity +
          '</span>' +
          '<button type="button" class="cart-drawer__qty-button" data-cart-quantity-change data-line="' +
          (index + 1) +
          '" data-quantity="' +
          (item.quantity + 1) +
          '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' +
          formatMoney(item.final_line_price, currency) +
          '</p>' +
          '</div>' +
          '</div>' +
          '</article>'
        );
      }

      function renderCart(cart, notifyCartPage) {
        if (!itemsContainer || !emptyState || !subtotalElement) {
          return;
        }

        if (!cart.items || !cart.items.length) {
          itemsContainer.innerHTML = '';
          emptyState.hidden = false;
        } else {
          emptyState.hidden = true;
          itemsContainer.innerHTML = cart.items
            .map(function (item, index) {
              return buildCartItem(item, index, cart.currency);
            })
            .join('');
        }

        subtotalElement.textContent = formatMoney(cart.total_price, cart.currency);
        updateCartDots(cart.item_count || 0);

        if (notifyCartPage !== false) {
          document.dispatchEvent(new CustomEvent('cart:drawer-updated', { detail: { cart: cart } }));
        }
      }

      document.addEventListener('cart:updated', function (event) {
        if (event.detail && event.detail.cart) {
          renderCart(event.detail.cart, false);
        }
      });

      function openDrawer() {
        drawer.classList.add('is-open');
        document.body.classList.add('cart-drawer-open');
        if (panel) {
          panel.setAttribute('aria-hidden', 'false');
          panel.removeAttribute('inert');
          panel.focus();
        }
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        document.body.classList.remove('cart-drawer-open');
        if (panel) {
          panel.setAttribute('aria-hidden', 'true');
          panel.setAttribute('inert', '');
        }
      }

      function fetchCart(openAfterLoad) {
        if (isLoading) {
          return;
        }

        isLoading = true;

        fetch(cartUrl, {
          credentials: 'same-origin'
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            renderCart(cart);
            if (openAfterLoad) {
              openDrawer();
            }
          })
          .catch(function () {})
          .finally(function () {
            isLoading = false;
          });
      }

      function changeQuantity(line, quantity) {
        if (isLoading) {
          return;
        }

        isLoading = true;
        drawer.setAttribute('aria-busy', 'true');

        fetch(cartChangeUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: Number(line),
            quantity: Number(quantity)
          })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            renderCart(cart);
          })
          .catch(function () {})
          .finally(function () {
            isLoading = false;
            drawer.setAttribute('aria-busy', 'false');
          });
      }

      function saveCartNote(note) {
        if (cartNoteStatus) {
          cartNoteStatus.textContent = 'Saving…';
        }

        return fetch(cartUpdateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ note: note })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Unable to save order notes');
            }

            return response.json();
          })
          .then(function () {
            lastSavedNote = note;
            if (cartNoteStatus) {
              cartNoteStatus.textContent = 'Saved';
            }
            return true;
          })
          .catch(function () {
            if (cartNoteStatus) {
              cartNoteStatus.textContent = 'Could not save. Please try again.';
            }
            return false;
          });
      }

      function getLineItemProperties(form) {
        var properties = {};

        if (!form || typeof FormData === 'undefined') {
          return properties;
        }

        new FormData(form).forEach(function (value, name) {
          var match = name.match(/^properties\[(.+)\]$/);

          if (!match || value === '') {
            return;
          }

          properties[match[1]] = value;
        });

        return properties;
      }

      function normaliseVariantId(value) {
        var variantId = String(value || '').trim();
        var gidMatch = variantId.match(/(?:^|\/)ProductVariant\/(\d+)$/i);

        return gidMatch ? gidMatch[1] : variantId;
      }

      function addItemToCart(variantId, quantity, submitButton, errorTarget, onSuccess, properties) {
        variantId = normaliseVariantId(variantId);

        if (!variantId || isLoading) {
          return;
        }

        isLoading = true;

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('is-loading');
          submitButton.setAttribute('aria-busy', 'true');
        }

        if (errorTarget) {
          errorTarget.hidden = true;
          errorTarget.textContent = '';
        }

        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: Number(quantity || 1),
            ...(properties && Object.keys(properties).length ? { properties: properties } : {})
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw data;
              });
            }

            return response.json();
          })
          .then(function () {
            isLoading = false;
            if (typeof onSuccess === 'function') {
              onSuccess();
            }
            fetchCart(true);
          })
          .catch(function (error) {
            if (errorTarget) {
              errorTarget.textContent =
                (error && error.description) || 'Unable to add this item to cart.';
              errorTarget.hidden = false;
            }
          })
          .finally(function () {
            if (isLoading) {
              isLoading = false;
            }

            if (submitButton) {
              submitButton.disabled = false;
              submitButton.classList.remove('is-loading');
              submitButton.removeAttribute('aria-busy');
            }
          });
      }

      function normaliseImageUrl(url) {
        if (!url) {
          return '';
        }

        if (url.indexOf('//') === 0) {
          return 'https:' + url;
        }

        return url;
      }

      function getPopupMediaItems(product) {
        var mediaItems = [];

        if (product && product.media && product.media.length) {
          product.media.forEach(function (media) {
            if (!media || media.media_type !== 'image') {
              return;
            }

            var src =
              (media.preview_image && (media.preview_image.src || media.preview_image.url)) ||
              media.src ||
              '';

            if (!src) {
              return;
            }

            mediaItems.push({
              id: String(media.id || src),
              src: normaliseImageUrl(src),
              alt: media.alt || product.title || 'Product'
            });
          });
        }

        if (!mediaItems.length && product && product.images && product.images.length) {
          product.images.forEach(function (image, index) {
            var src = '';

            if (typeof image === 'string') {
              src = image;
            } else if (image && image.src) {
              src = image.src;
            }

            if (!src) {
              return;
            }

            mediaItems.push({
              id: String((image && image.id) || index),
              src: normaliseImageUrl(src),
              alt: (image && image.alt) || product.title || 'Product'
            });
          });
        }

        return mediaItems;
      }

      function getPopupMediaIdFromVariant(variant, mediaItems, product) {
        if (!variant) {
          return mediaItems.length ? mediaItems[0].id : '';
        }

        if (variant.featured_media && variant.featured_media.id) {
          var featuredMediaMatch = mediaItems.find(function (item) {
            return item.id === String(variant.featured_media.id);
          });

          if (featuredMediaMatch) {
            return featuredMediaMatch.id;
          }
        }

        if (variant.featured_image && variant.featured_image.src) {
          var featuredImageSrc = normaliseImageUrl(variant.featured_image.src);
          var featuredImageMatch = mediaItems.find(function (item) {
            return item.src === featuredImageSrc;
          });

          if (featuredImageMatch) {
            return featuredImageMatch.id;
          }
        }

        if (product && product.featured_image && product.featured_image.src) {
          var productFeaturedSrc = normaliseImageUrl(product.featured_image.src);
          var productFeaturedMatch = mediaItems.find(function (item) {
            return item.src === productFeaturedSrc;
          });

          if (productFeaturedMatch) {
            return productFeaturedMatch.id;
          }
        }

        return mediaItems.length ? mediaItems[0].id : '';
      }

      function renderPopupMedia(product, popupElements) {
        if (!popupElements || !popupElements.mediaStage || !popupElements.thumbnails) {
          return;
        }

        var mediaItems = getPopupMediaItems(product);
        popupElements.mediaStage.innerHTML = '';
        popupElements.thumbnails.innerHTML = '';
        popupMediaIndex = 0;

        if (!mediaItems.length) {
          popupElements.mediaStage.innerHTML = '<div class="product-popup__image-placeholder"></div>';
          popupElements.thumbnails.hidden = true;
          if (popupElements.thumbnailsShell) {
            popupElements.thumbnailsShell.hidden = true;
          }
          return;
        }

        var mediaTrack = document.createElement('div');
        mediaTrack.className = 'product-popup__media-track';

        mediaItems.forEach(function (item, index) {
          var mediaNode = document.createElement('div');
          mediaNode.className = 'product-popup__media-item' + (index === 0 ? ' is-active' : '');
          mediaNode.setAttribute('data-product-popup-media-item', '');
          mediaNode.setAttribute('data-media-id', item.id);

          var mediaImage = document.createElement('img');
          mediaImage.className = 'product-popup__image';
          mediaImage.src = item.src;
          mediaImage.alt = item.alt;
          mediaImage.loading = 'lazy';
          mediaNode.appendChild(mediaImage);
          mediaTrack.appendChild(mediaNode);

          var thumbButton = document.createElement('button');
          thumbButton.type = 'button';
          thumbButton.className = 'product-popup__thumbnail' + (index === 0 ? ' is-active' : '');
          thumbButton.setAttribute('data-product-popup-thumbnail', '');
          thumbButton.setAttribute('data-media-id', item.id);
          thumbButton.setAttribute('aria-label', 'Show image ' + (index + 1));

          var thumbImage = document.createElement('img');
          thumbImage.className = 'product-popup__thumbnail-image';
          thumbImage.src = item.src;
          thumbImage.alt = item.alt;
          thumbImage.loading = 'lazy';
          thumbButton.appendChild(thumbImage);
          popupElements.thumbnails.appendChild(thumbButton);
        });

        popupElements.mediaStage.appendChild(mediaTrack);
        popupElements.thumbnails.hidden = false;
        if (popupElements.thumbnailsShell) {
          popupElements.thumbnailsShell.hidden = mediaItems.length < 2;
        }
        if (popupElements.mediaPrev) {
          popupElements.mediaPrev.hidden = mediaItems.length < 2;
        }
        if (popupElements.mediaNext) {
          popupElements.mediaNext.hidden = mediaItems.length < 2;
        }
      }

      function setActivePopupMedia(mediaId) {
        var popupElements = getPopupElements();

        if (!popupElements || !popupElements.mediaStage || !popupElements.thumbnails) {
          return;
        }

        var mediaItems = popupElements.mediaStage.querySelectorAll('[data-product-popup-media-item]');
        var mediaTrack = popupElements.mediaStage.querySelector('.product-popup__media-track');

        mediaItems.forEach(function (item, index) {
          var isActive = String(item.getAttribute('data-media-id')) === String(mediaId);
          item.classList.toggle('is-active', isActive);
          if (isActive) {
            popupMediaIndex = index;
          }
        });

        popupElements.thumbnails.querySelectorAll('[data-product-popup-thumbnail]').forEach(function (item) {
          var isActive = String(item.getAttribute('data-media-id')) === String(mediaId);
          item.classList.toggle('is-active', isActive);
          if (isActive && typeof item.scrollIntoView === 'function') {
            item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });

        if (mediaTrack) {
          mediaTrack.style.transform = 'translate3d(' + popupMediaIndex * -100 + '%, 0, 0)';
        }
      }

      function stepPopupMedia(direction) {
        var popupElements = getPopupElements();

        if (!popupElements || !popupElements.mediaStage) {
          return;
        }

        var mediaItems = popupElements.mediaStage.querySelectorAll('[data-product-popup-media-item]');

        if (!mediaItems.length) {
          return;
        }

        popupMediaIndex = popupMediaIndex + direction;

        if (popupMediaIndex < 0) {
          popupMediaIndex = mediaItems.length - 1;
        }

        if (popupMediaIndex >= mediaItems.length) {
          popupMediaIndex = 0;
        }

        setActivePopupMedia(mediaItems[popupMediaIndex].getAttribute('data-media-id'));
      }

      function scrollPopupThumbnails(direction) {
        var popupElements = getPopupElements();

        if (!popupElements || !popupElements.thumbnails) {
          return;
        }

        popupElements.thumbnails.scrollBy({
          left: direction * 180,
          behavior: 'smooth'
        });
      }

      function getPopupElements() {
        if (!productPopup) {
          return null;
        }

        return {
          panel: productPopup.querySelector('.product-popup__panel'),
          mediaStage: productPopup.querySelector('[data-product-popup-media-stage]'),
          thumbnailsShell: productPopup.querySelector('[data-product-popup-thumbnails-shell]'),
          thumbnails: productPopup.querySelector('[data-product-popup-thumbnails]'),
          mediaPrev: productPopup.querySelector('[data-product-popup-media-prev]'),
          mediaNext: productPopup.querySelector('[data-product-popup-media-next]'),
          thumbPrev: productPopup.querySelector('[data-product-popup-thumb-prev]'),
          thumbNext: productPopup.querySelector('[data-product-popup-thumb-next]'),
          title: productPopup.querySelector('[data-product-popup-title]'),
          price: productPopup.querySelector('[data-product-popup-price]'),
          options: productPopup.querySelector('[data-product-popup-options]'),
          status: productPopup.querySelector('[data-product-popup-status]'),
          error: productPopup.querySelector('[data-product-popup-error]'),
          addButton: productPopup.querySelector('[data-product-popup-add]'),
          buyNowButton: productPopup.querySelector('[data-product-popup-buy-now]')
        };
      }

      function getFirstAvailableVariant(product) {
        if (!product || !product.variants || !product.variants.length) {
          return null;
        }

        for (var index = 0; index < product.variants.length; index += 1) {
          if (product.variants[index].available) {
            return product.variants[index];
          }
        }

        return product.variants[0];
      }

      function getVariantFromSelections(product, selections) {
        if (!product || !product.variants) {
          return null;
        }

        for (var index = 0; index < product.variants.length; index += 1) {
          var variant = product.variants[index];
          var matches = true;

          for (var optionIndex = 0; optionIndex < selections.length; optionIndex += 1) {
            if (variant['option' + (optionIndex + 1)] !== selections[optionIndex]) {
              matches = false;
              break;
            }
          }

          if (matches) {
            return variant;
          }
        }

        return null;
      }

      function getMatchingPopupVariantsForOption(product, optionIndex, value, selections) {
        if (!product || !product.variants) {
          return [];
        }

        return product.variants.filter(function (variant) {
          if (variant['option' + (optionIndex + 1)] !== value) {
            return false;
          }

          for (var index = 0; index < selections.length; index += 1) {
            if (index === optionIndex || !selections[index]) {
              continue;
            }

            if (variant['option' + (index + 1)] !== selections[index]) {
              return false;
            }
          }

          return true;
        });
      }

      function buildPriceMarkup(variant) {
        if (!variant) {
          return '';
        }

        var comparePrice = Number(variant.compare_at_price || 0);
        var price = Number(variant.price || 0);
        var isOnSale = comparePrice > price;
        var html = '';

        if (!isOnSale) {
          html += '<span class="product-popup__price-prefix">From</span>';
        }

        html += '<span class="product-popup__price">' + formatMoney(price) + '</span>';

        if (isOnSale) {
          html += '<span class="product-popup__compare">' + formatMoney(comparePrice) + '</span>';
        }

        return html;
      }

      function renderPopupOptions(product, popupElements) {
        if (!product || !popupElements || !popupElements.options) {
          return;
        }

        popupElements.options.innerHTML = '';
        var selectorStyle =
          (productPopup && productPopup.getAttribute('data-variant-selector-style')) || 'select';

        if (!product.options || !product.options.length) {
          return;
        }

        product.options.forEach(function (optionName, optionIndex) {
          var field = document.createElement('div');
          field.className = 'product-popup__field';

          var label = document.createElement('label');
          label.className = 'product-popup__label';
          label.textContent = optionName;

          var seenValues = {};
          var values = [];

          product.variants.forEach(function (variant) {
            var value = variant['option' + (optionIndex + 1)];

            if (!value || seenValues[value]) {
              return;
            }

            seenValues[value] = true;
            values.push(value);
          });

          field.appendChild(label);

          if (selectorStyle === 'buttons') {
            var buttonGroup = document.createElement('div');
            buttonGroup.className = 'product-popup__button-group';
            buttonGroup.setAttribute('data-product-popup-option-group', String(optionIndex));

            values.forEach(function (value) {
              var optionButton = document.createElement('button');
              optionButton.type = 'button';
              optionButton.className =
                'product-popup__option-button' +
                (popupSelections[optionIndex] === value ? ' is-active' : '');
              optionButton.setAttribute('data-product-popup-option-button', '');
              optionButton.setAttribute('data-product-popup-option-index', String(optionIndex));
              optionButton.setAttribute('data-product-popup-option-value', value);
              optionButton.textContent = value;
              buttonGroup.appendChild(optionButton);
            });

            field.appendChild(buttonGroup);
          } else {
            var select = document.createElement('select');
            select.className = 'product-popup__select';
            select.id = 'product-popup-option-' + optionIndex;
            select.setAttribute('data-product-popup-option-index', String(optionIndex));

            values.forEach(function (value) {
              var option = document.createElement('option');
              option.value = value;
              option.textContent = value;

              if (popupSelections[optionIndex] === value) {
                option.selected = true;
              }

              select.appendChild(option);
            });

            field.appendChild(select);
          }

          popupElements.options.appendChild(field);
        });
      }

      function updatePopupOptionButtonAvailability() {
        if (!productPopup || !popupProduct) {
          return;
        }

        productPopup.querySelectorAll('[data-product-popup-option-group]').forEach(function (group) {
          var optionIndex = Number(group.getAttribute('data-product-popup-option-group'));

          group.querySelectorAll('.product-popup__option-button').forEach(function (button) {
            var optionValue = button.getAttribute('data-product-popup-option-value') || '';
            var matchingVariants = getMatchingPopupVariantsForOption(
              popupProduct,
              optionIndex,
              optionValue,
              popupSelections
            );
            var hasAvailableVariant = matchingVariants.some(function (variant) {
              return Boolean(variant.available);
            });

            button.classList.toggle('is-unavailable', !hasAvailableVariant);
          });
        });
      }

      function updatePopupState() {
        var popupElements = getPopupElements();

        if (!popupProduct || !popupElements) {
          return;
        }

        popupVariant = getVariantFromSelections(popupProduct, popupSelections);

        popupElements.price.innerHTML = buildPriceMarkup(popupVariant);
        popupElements.error.hidden = true;
        popupElements.error.textContent = '';
        updatePopupOptionButtonAvailability();

        if (!popupVariant || !popupVariant.available) {
          popupElements.status.hidden = false;
          popupElements.status.textContent = 'This option is currently sold out.';
          popupElements.addButton.disabled = true;
          popupElements.buyNowButton.disabled = true;
        } else {
          popupElements.status.hidden = true;
          popupElements.status.textContent = '';
          popupElements.addButton.disabled = false;
          popupElements.buyNowButton.disabled = false;
        }

        var popupMediaItems = getPopupMediaItems(popupProduct);
        var activeMediaId = getPopupMediaIdFromVariant(popupVariant, popupMediaItems, popupProduct);

        if (activeMediaId) {
          setActivePopupMedia(activeMediaId);
        }
      }

      function closeProductPopup() {
        var popupElements = getPopupElements();

        if (!productPopup || !popupElements) {
          return;
        }

        productPopup.classList.remove('is-open');
        document.body.classList.remove('product-popup-open');
        popupElements.panel.setAttribute('aria-hidden', 'true');
        popupElements.panel.setAttribute('inert', '');
        popupProduct = null;
        popupVariant = null;
        popupSelections = [];
      }

      function openProductPopup(productData) {
        var popupElements = getPopupElements();

        if (!productPopup || !popupElements || !productData) {
          return;
        }

        popupProduct = productData;

        var initialVariant = getFirstAvailableVariant(productData);
        popupSelections = (productData.options || []).map(function (_, index) {
          return initialVariant ? initialVariant['option' + (index + 1)] || '' : '';
        });

        popupElements.title.textContent = productData.title || 'Product';
        renderPopupMedia(productData, popupElements);
        renderPopupOptions(productData, popupElements);
        updatePopupState();

        productPopup.classList.add('is-open');
        document.body.classList.add('product-popup-open');
        popupElements.panel.setAttribute('aria-hidden', 'false');
        popupElements.panel.removeAttribute('inert');
        popupElements.panel.focus();
      }

      document.querySelectorAll('.icon-cart').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          fetchCart(true);
        });
      });

      document.addEventListener('submit', function (event) {
        var mainProductForm = event.target.closest('[data-product-main-form]');

        if (mainProductForm) {
          var mainProductSubmit = mainProductForm.querySelector('[data-product-submit]');

          // Leave Shopify's dynamic checkout buttons to submit normally.
          if (event.submitter && !event.submitter.matches('[data-product-submit]')) {
            return;
          }

          event.preventDefault();

          var mainProductSection = mainProductForm.closest('[data-main-product]');
          var mainVariantInput = mainProductForm.querySelector('input[name="id"]');
          var mainQuantityInput = mainProductSection
            ? mainProductSection.querySelector('[data-product-quantity]')
            : null;
          var mainProductError = mainProductForm.querySelector('[data-product-main-error]');

          addItemToCart(
            mainVariantInput ? mainVariantInput.value : '',
            mainQuantityInput ? mainQuantityInput.value : 1,
            mainProductSubmit,
            mainProductError,
            null,
            getLineItemProperties(mainProductForm)
          );
          return;
        }

        var addForm = event.target.closest('[data-product-item-add-form]');

        if (!addForm) {
          return;
        }

        event.preventDefault();

        var variantInput = addForm.querySelector('input[name="id"]');
        var quantityInput = addForm.querySelector('input[name="quantity"]');
        var submitButton = addForm.querySelector('button[type="submit"]');
        var errorTarget = addForm.querySelector('[data-product-item-error]');

        addItemToCart(
          variantInput ? variantInput.value : '',
          quantityInput ? quantityInput.value : 1,
          submitButton,
          errorTarget
        );
      });

      document.addEventListener('click', function (event) {
        var popupTrigger = event.target.closest('[data-product-item-trigger]');

        if (popupTrigger) {
          var productItem = popupTrigger.closest('.product-item');
          var jsonNode = productItem ? productItem.querySelector('[data-product-item-json]') : null;
          var productData = null;

          if (!jsonNode) {
            return;
          }

          try {
            productData = JSON.parse(jsonNode.textContent);
          } catch (error) {
            productData = null;
          }

          if (!productData) {
            return;
          }

          openProductPopup(productData);
          return;
        }

        if (event.target.closest('[data-product-popup-close]')) {
          closeProductPopup();
          return;
        }

        if (event.target.closest('[data-product-popup-add]')) {
          var popupElements = getPopupElements();

          if (!popupVariant || !popupElements) {
            return;
          }

          addItemToCart(
            popupVariant.id,
            1,
            popupElements.addButton,
            popupElements.error,
            closeProductPopup
          );
          return;
        }

        if (event.target.closest('[data-product-popup-buy-now]')) {
          if (!popupVariant || !popupVariant.available) {
            return;
          }

          window.location.href = rootPath + 'cart/' + popupVariant.id + ':1?checkout';
        }
      });

      if (productPopup) {
        var popupElements = getPopupElements();
        var popupBuyNowEnabled = productPopup.getAttribute('data-enable-buy-now') === 'true';

        if (popupElements && popupElements.buyNowButton) {
          popupElements.buyNowButton.hidden = !popupBuyNowEnabled;
        }

        productPopup.addEventListener('change', function (event) {
          var select = event.target.closest('[data-product-popup-option-index]');

          if (!select) {
            return;
          }

          var optionIndex = Number(select.getAttribute('data-product-popup-option-index'));
          popupSelections[optionIndex] = select.value;
          updatePopupState();
        });

        productPopup.addEventListener('click', function (event) {
          if (event.target.closest('[data-product-popup-media-prev]')) {
            stepPopupMedia(-1);
            return;
          }

          if (event.target.closest('[data-product-popup-media-next]')) {
            stepPopupMedia(1);
            return;
          }

          if (event.target.closest('[data-product-popup-thumb-prev]')) {
            scrollPopupThumbnails(-1);
            return;
          }

          if (event.target.closest('[data-product-popup-thumb-next]')) {
            scrollPopupThumbnails(1);
            return;
          }

          var thumbnailButton = event.target.closest('[data-product-popup-thumbnail]');

          if (thumbnailButton) {
            setActivePopupMedia(thumbnailButton.getAttribute('data-media-id'));
            return;
          }

          var optionButton = event.target.closest('[data-product-popup-option-button]');

          if (!optionButton) {
            return;
          }

          var optionIndex = Number(optionButton.getAttribute('data-product-popup-option-index'));
          var optionValue = optionButton.getAttribute('data-product-popup-option-value') || '';
          var group = productPopup.querySelector('[data-product-popup-option-group="' + optionIndex + '"]');

          if (!group) {
            return;
          }

          group.querySelectorAll('.product-popup__option-button').forEach(function (button) {
            button.classList.toggle('is-active', button === optionButton);
          });

          popupSelections[optionIndex] = optionValue;
          updatePopupState();
        });
      }

      drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (element) {
        element.addEventListener('click', function () {
          closeDrawer();
        });
      });

      drawer.addEventListener('click', function (event) {
        var quantityButton = event.target.closest('[data-cart-quantity-change]');
        var removeButton = event.target.closest('[data-cart-remove]');

        if (quantityButton) {
          changeQuantity(
            quantityButton.getAttribute('data-line'),
            quantityButton.getAttribute('data-quantity')
          );
        }

        if (removeButton) {
          changeQuantity(removeButton.getAttribute('data-line'), 0);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeProductPopup();
          closeDrawer();
        }
      });

      if (cartNoteInput) {
        cartNoteInput.addEventListener('input', function () {
          window.clearTimeout(noteSaveTimer);
          if (cartNoteStatus) {
            cartNoteStatus.textContent = 'Unsaved';
          }

          noteSaveTimer = window.setTimeout(function () {
            saveCartNote(cartNoteInput.value);
          }, 600);
        });
      }

      if (checkoutButton) {
        checkoutButton.addEventListener('click', function () {
          if (!validatePolicy(drawer)) {
            return;
          }

          window.clearTimeout(noteSaveTimer);

          if (cartNoteInput && cartNoteInput.value !== lastSavedNote) {
            checkoutButton.disabled = true;
            saveCartNote(cartNoteInput.value).then(function (saved) {
              if (saved) {
                window.location.href = rootPath + 'checkout';
                return;
              }

              checkoutButton.disabled = false;
            });
            return;
          }

          window.location.href = rootPath + 'checkout';
        });
      }

      var drawerCheckbox = drawer.querySelector('[data-cart-policy-checkbox]');
      var drawerError = drawer.querySelector('[data-cart-policy-error]');

      if (drawerCheckbox && drawerError) {
        drawerCheckbox.addEventListener('change', function () {
          drawerError.hidden = drawerCheckbox.checked;
        });
      }

      fetchCart(false);
    }

    function initRevealOnScroll() {
      var revealItems = document.querySelectorAll('.reveal-on-scroll');

      if (!revealItems.length) {
        return;
      }

      if (!window.IntersectionObserver) {
        revealItems.forEach(function (item) {
          item.classList.add('is-visible');
        });
        return;
      }

      var revealObserver = new window.IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.16,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      revealItems.forEach(function (item) {
        if (!item.classList.contains('is-visible')) {
          revealObserver.observe(item);
        }
      });
    }

    function initInstagramVideoPopup() {
      document.querySelectorAll('.instagram-video-popup').forEach(function (popup) {
        var panel = popup.querySelector('[data-instagram-video-panel]');
        var closeButton = popup.querySelector('[data-instagram-video-close]');
        var openButton = popup.querySelector('[data-instagram-video-open]');
        var video = popup.querySelector('.instagram-video-popup__video');
        var storageKey = 'nolters-instagram-video-popup-closed';
        var rememberClosedState = popup.getAttribute('data-remember-closed') === 'true';
        var videoLoaded = false;

        if (!panel || !closeButton || !openButton) {
          return;
        }

        function getStoredClosedState() {
          if (!rememberClosedState) {
            return false;
          }

          try {
            return window.localStorage.getItem(storageKey) === 'true';
          } catch (error) {
            return false;
          }
        }

        function storeClosedState(isClosed) {
          if (!rememberClosedState) {
            try {
              window.localStorage.removeItem(storageKey);
            } catch (error) {}
            return;
          }

          try {
            window.localStorage.setItem(storageKey, isClosed ? 'true' : 'false');
          } catch (error) {}
        }

        function loadAndPlayVideo() {
          if (!video) {
            return;
          }

          if (!videoLoaded) {
            video.querySelectorAll('source[data-src]').forEach(function (source) {
              source.src = source.getAttribute('data-src');
              source.removeAttribute('data-src');
            });
            video.load();
            videoLoaded = true;
          }

          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }

        function setPopupClosed(isClosed, loadMedia) {
          popup.classList.toggle('is-closed', isClosed);
          storeClosedState(isClosed);

          if (video) {
            if (isClosed) {
              video.pause();
            } else if (loadMedia) {
              loadAndPlayVideo();
            }
          }
        }

        closeButton.addEventListener('click', function () {
          setPopupClosed(true, false);
        });

        openButton.addEventListener('click', function () {
          setPopupClosed(false, true);
        });

        setPopupClosed(getStoredClosedState(), false);

        function playAfterInteraction() {
          if (!popup.classList.contains('is-closed')) {
            loadAndPlayVideo();
          }
        }

        window.addEventListener('pointerdown', playAfterInteraction, { once: true, passive: true });
        window.addEventListener('touchstart', playAfterInteraction, { once: true, passive: true });
        window.addEventListener('keydown', playAfterInteraction, { once: true });
      });
    }

    var bannerInitialized = false;

    function bindHeaderStateListeners() {
      if (bindHeaderStateListeners.didBind) {
        return;
      }

      bindHeaderStateListeners.didBind = true;

      window.addEventListener('resize', function () {
        updateHeaderDependentUI();
        updateHeaderScrollState();
      });

      window.addEventListener('scroll', function () {
        updateHeaderScrollState();
      });
    }

    function bootThemeUI() {
      if (bootThemeUI.didRun) {
        return;
      }

      bootThemeUI.didRun = true;
      bindHeaderStateListeners();
      initAnnouncementBar();
      initHeaderSearch();
      initHeaderInteractions();
      bannerInitialized = initIndexBanner();
      initBackToTop();
      initInstagramVideoPopup();
      initReviewsSliders();
      initCollectionProductSliders();
      initCartDrawer();
      initRevealOnScroll();
      updateHeaderDependentUI();
      updateHeaderScrollState();

      window.setTimeout(function () {
        initHeaderInteractions();
        updateHeaderDependentUI();
        updateHeaderScrollState();
      }, 300);
    }

    bootThemeUI();

    if (!bannerInitialized) {
      window.addEventListener('load', function () {
        initHeaderInteractions();
        updateHeaderDependentUI();
        updateHeaderScrollState();
        initIndexBanner();
        initReviewsSliders();
        initCollectionProductSliders();
      });
    }

    var resizeHeaderElement = getHeaderElement();
    if (window.ResizeObserver && resizeHeaderElement) {
      var headerResizeObserver = new window.ResizeObserver(function () {
        updateHeaderDependentUI();
        updateHeaderScrollState();
      });

      headerResizeObserver.observe(resizeHeaderElement);
    }

    var resizeAnnouncementElement = getAnnouncementBarElement();
    if (window.ResizeObserver && resizeAnnouncementElement) {
      var announcementResizeFrame = null;
      var announcementResizeObserver = new window.ResizeObserver(function () {
        if (announcementResizeFrame !== null) {
          return;
        }

        announcementResizeFrame = window.requestAnimationFrame(function () {
          announcementResizeFrame = null;
          updateHeaderDependentUI();
          updateHeaderScrollState();
          window.dispatchEvent(new CustomEvent('header:heightchange'));
        });
      });

      announcementResizeObserver.observe(resizeAnnouncementElement);
    }

  });
})();
